(function () {
  const GLOBAL_KEY = "__repairStatusWidget";
  const ANALYTICS_EVENT_NAME = "repair_status_search";

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].init(document);
    return;
  }

  const widgetApi = {
    init(scope) {
      initWidgets(scope || document);
    },
  };

  window[GLOBAL_KEY] = widgetApi;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => widgetApi.init(document));
  } else {
    widgetApi.init(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    widgetApi.init(event.target);
  });

  document.addEventListener("shopify:section:select", (event) => {
    widgetApi.init(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    widgetApi.init(event.target);
  });

  function initWidgets(scope) {
    const roots = scope.querySelectorAll("[data-repair-status-widget]");

    roots.forEach((root) => {
      if (root.dataset.repairStatusBound === "true") return;

      const form = root.querySelector(".repair-status-widget__form");
      const button = root.querySelector(".repair-status-widget__button");

      if (!form || !button) return;

      root.dataset.repairStatusBound = "true";
      button.dataset.defaultLabel = decodeEntities(button.textContent.trim());
      form.addEventListener("submit", onSubmit);
    });
  }

  async function onSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const root = form.closest("[data-repair-status-widget]");
    if (!root) return;

    const input = form.querySelector(".repair-status-widget__input");
    if (!input) return;

    const searchQuery = input.value.trim();

    if (!searchQuery) {
      clearResult(root);
      setMessage(root, root.dataset.emptyMessage, "error");
      input.focus();
      return;
    }

    trackRepairStatusSearch(root);

    setBusy(root, true);
    setMessage(root, root.dataset.loadingMessage, "default");
    clearResult(root);

    try {
      const payload = await fetchLookup(root.dataset.lookupUrl, searchQuery);
      const repair = normalizeRepairPayload(payload);

      renderRepair(root, repair);
      clearMessage(root);
    } catch (error) {
      clearResult(root);
      setMessage(root, getErrorMessage(root, error), "error");
    } finally {
      setBusy(root, false);
    }
  }

  async function fetchLookup(lookupUrl, searchQuery) {
    const url = new URL(lookupUrl, window.location.origin);
    url.searchParams.set("searchQuery", searchQuery);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    const payload = await readJson(response);

    if (!response.ok) {
      throw createLookupError(response, payload);
    }

    if (!payload) {
      throw new Error("");
    }

    return payload;
  }

  function normalizeRepairPayload(payload) {
    if (payload && payload.success === true && payload.repair) {
      return {
        number: payload.repair.number,
        status: payload.repair.status,
        orderDate: payload.repair.orderDate,
        imei: payload.repair.imei,
        serialNo: payload.repair.serialNo,
        faultDescription: payload.repair.faultDescription,
        resolutionDescription: payload.repair.resolutionDescription,
        inputPackageNo: payload.repair.inputPackageNo,
        outputPackageNo: payload.repair.outputPackageNo,
      };
    }

    return {
      number: payload.No || payload.no || payload.number || "",
      status: payload.Status || payload.status || "",
      orderDate: payload.Order_Date || payload.orderDate || payload.order_date || "",
      imei: payload.IMEI || payload.imei || "",
      serialNo: payload.SerialNo || payload.serialNo || payload.serial_no || "",
      faultDescription:
        payload.FaultDestription ||
        payload.FaultDescription ||
        payload.faultDescription ||
        payload.fault_description ||
        "",
      resolutionDescription:
        payload.ResolutionDescription ||
        payload.resolutionDescription ||
        payload.resolution_description ||
        "",
      inputPackageNo:
        payload.Input_Package_No ||
        payload.inputPackageNo ||
        payload.input_package_no ||
        "",
      outputPackageNo:
        payload.Output_Package_No ||
        payload.outputPackageNo ||
        payload.output_package_no ||
        "",
    };
  }

  async function readJson(response) {
    const contentType = response.headers.get("content-type") || "";

    if (!contentType.includes("application/json")) {
      return null;
    }

    try {
      return await response.json();
    } catch {
      return null;
    }
  }

  function createLookupError(response, payload) {
    const error = new Error(payload && payload.message ? payload.message : "");
    error.status = response.status;
    return error;
  }

  function renderRepair(root, repair) {
    const result = root.querySelector("[data-repair-status-result]");
    if (!result) return;

    const fields = [
      [root.dataset.numberLabel, repair.number],
      [root.dataset.statusLabel, repair.status],
      [root.dataset.orderDateLabel, repair.orderDate],
      [root.dataset.imeiLabel, repair.imei],
      [root.dataset.serialNoLabel, repair.serialNo],
      [root.dataset.faultDescriptionLabel, repair.faultDescription],
      [root.dataset.resolutionDescriptionLabel, repair.resolutionDescription],
      [root.dataset.inputPackageNoLabel, repair.inputPackageNo],
      [root.dataset.outputPackageNoLabel, repair.outputPackageNo],
    ].filter(([, value]) => Boolean(value));

    if (!fields.length) {
      throw new Error(root.dataset.invalidResponseMessage || "");
    }

    result.innerHTML =
      '<dl class="repair-status-widget__result-grid">' +
      fields
        .map(([label, value]) => {
          return (
            '<div class="repair-status-widget__result-item">' +
            '<dt class="repair-status-widget__result-label">' +
            escapeHtml(label || "") +
            "</dt>" +
            '<dd class="repair-status-widget__result-value">' +
            escapeHtml(value || "") +
            "</dd>" +
            "</div>"
          );
        })
        .join("") +
      "</dl>";

    result.hidden = false;
  }

  function clearResult(root) {
    const result = root.querySelector("[data-repair-status-result]");
    if (!result) return;

    result.hidden = true;
    result.innerHTML = "";
  }

  function setMessage(root, message, tone) {
    const messageElement = root.querySelector("[data-repair-status-message]");
    if (!messageElement) return;

    messageElement.dataset.tone = tone || "default";
    messageElement.textContent = decodeEntities(message || "");
    messageElement.hidden = !message;
  }

  function clearMessage(root) {
    setMessage(root, "", "default");
  }

  function setBusy(root, busy) {
    const button = root.querySelector(".repair-status-widget__button");
    if (!button) return;

    root.setAttribute("aria-busy", busy ? "true" : "false");
    button.disabled = busy;
    button.textContent = decodeEntities(
      busy
        ? root.dataset.loadingButtonLabel || button.dataset.defaultLabel || ""
        : button.dataset.defaultLabel || ""
    );
  }

  function getErrorMessage(root, error) {
    if (isNotFoundError(error)) {
      return decodeEntities(root.dataset.invalidResponseMessage || root.dataset.errorMessage || "");
    }

    if (error instanceof Error && error.message) {
      if (isLoadFailure(error.message)) {
        return decodeEntities(root.dataset.loadFailedMessage || root.dataset.errorMessage || "");
      }

      return decodeEntities(error.message);
    }

    return decodeEntities(root.dataset.errorMessage || "");
  }

  function isNotFoundError(error) {
    return Boolean(error && typeof error === "object" && error.status === 404);
  }

  function isLoadFailure(message) {
    const normalizedMessage = String(message || "").trim();

    return (
      normalizedMessage === "Load failed" ||
      normalizedMessage === "Failed to fetch" ||
      normalizedMessage === "NetworkError when attempting to fetch resource."
    );
  }

  function trackRepairStatusSearch(root) {
    const eventParams = {
      event_category: "repair_status",
      event_label: "lookup_submit",
      lookup_source: "repair_status_widget",
    };

    if (root && root.id) {
      eventParams.widget_id = root.id;
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", ANALYTICS_EVENT_NAME, eventParams);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: ANALYTICS_EVENT_NAME,
      ...eventParams,
    });
  }

  function decodeEntities(value) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = String(value || "");
    return textarea.value;
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }
})();
